import React, { useEffect, useRef, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Grid } from '@mui/material';

const MuiResponsivePhoneInputControlled = ({
    userData,
    setMobile,
}) => {
    const [phone, setPhone] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        if (userData?.country_code && userData?.mobile_number) {
            const fullNumber = `+${userData.country_code}${userData.mobile_number}`;
            setPhone(fullNumber);
        }
    }, [userData]);

    // Handle dropdown tracking
    useEffect(() => {
        const interval = setInterval(() => {
            const dropdown = document.querySelector('.country-list');
            setIsDropdownOpen(dropdown && dropdown.offsetParent !== null);
        }, 200);
        return () => clearInterval(interval);
    }, []);

    const handleChange = (val, data) => {
        const numberOnly = val.replace(`+${data.dialCode}`, '').replace(/\D/g, '');
        setPhone(val);
        setMobile({
            full: val,
            dialCode: data.dialCode,
            number: numberOnly,
        });
    };

    return (
        <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={11}
            sx={{
                overflow: 'visible',
                transition: 'height 0.5s ease',
                minHeight: isDropdownOpen ? '35vh' : 'auto',
            }}
            ref={containerRef}
        >
            <PhoneInput
                country={countryCode}
                enableSearch
                value={phone}
                onChange={handleChange}
                inputStyle={{
                    width: '100%',
                    fontSize: '1rem',
                }}
                dropdownStyle={{
                    width: '30vw',
                    zIndex: 9999,
                }}
                buttonStyle={{
                    width: '50px',
                }}
                searchStyle={{
                    width: '25vw',
                    zIndex: 9999,
                }}
                inputProps={{
                    name: 'phone',
                    required: true,
                    autoFocus: true,
                    autoComplete: 'off',
                }}
            />
        </Grid>
    );
};

export default MuiResponsivePhoneInputControlled;
